import { forwardRef, useLayoutEffect, useRef, useState } from 'react';

const InternationalPhoneNumberInput = forwardRef(
  (
    {
      customInputClassName = '',
      customInputWrapperClassName = '',
      defaultCountry,
      defaultNumber,
      disableHiddenField,
      disablePhoneInput = false,
      hideOptionalPlaceholder,
      inputName,
      isRequired,
      limitToUSOnly,
      onChange,
    },
    intlPhoneRef
  ) => {
    const phoneInput = intlPhoneRef || useRef(null);

    useLayoutEffect(() => {
      async function initializePhoneInput(input) {
        const { default: intlTelInput } = await import('intl-tel-input');
        const selectedCountries = limitToUSOnly ? ['us'] : [];

        window.iti = intlTelInput(input, {
          allowDropdown: !limitToUSOnly,
          initialCountry: defaultCountryIso(),
          customPlaceholder: (
            selectedCountryPlaceholder,
            _selectedCountryData
          ) =>
            `${selectedCountryPlaceholder}${
              !isRequired && !hideOptionalPlaceholder ? ' (optional)' : ''
            }`,
          onlyCountries: selectedCountries,
        });

        intlTelInputGlobals.loadUtils(
          'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/14.0.4/js/utils.js'
        );

        if (defaultNumber) {
          iti.setNumber(defaultNumber);
          setFullPhoneNumber(defaultNumber);
          setSelectedCountry(iti.defaultCountry);
        }

        input.addEventListener('countrychange', () => {
          handleOnChange();
        });
      }

      initializePhoneInput(phoneInput.current);
    }, []);

    const [fullPhoneNumber, setFullPhoneNumber] = useState(defaultNumber || '');

    const [selectedCountry, setSelectedCountry] = useState('');

    const defaultCountryIso = () => defaultCountry.replace('uk', 'gb');

    const handleOnChange = () => {
      if (window.iti === undefined) return;
      setSelectedCountry(window.iti.getSelectedCountryData().iso2);

      const newNumber = window.iti.getNumber();
      if (window.iti.isValidNumber() || newNumber === '') {
        setFullPhoneNumber(newNumber);
        if (onChange) onChange(newNumber);
      }
    };

    return (
      <>
        <div className={`input-wrapper ${customInputWrapperClassName}`}>
          <input
            type='hidden'
            value={fullPhoneNumber}
            {...(inputName && !disableHiddenField ? { name: inputName } : {})}
          />
          <input
            name='phone_number_country'
            type='hidden'
            value={selectedCountry}
          />
          <input
            className={`rounded border-grey-40 ${customInputClassName}`}
            data-parsley-intl-tel-input-phone-number={
              limitToUSOnly ? 'us-only' : ''
            }
            disabled={disablePhoneInput}
            id='phoneNumber'
            onChange={handleOnChange}
            ref={phoneInput}
            required={isRequired}
            type='tel'
            {...(inputName && disableHiddenField ? { name: inputName } : {})}
          />
        </div>
      </>
    );
  }
);

export default InternationalPhoneNumberInput;
